import { RootState } from '@/App/store';

export const selectLocale = (state: RootState) => state.i18n.locale;
